export default {"src":"/login-app/[GIT_HASH]/_next/static/media/cost_euro.b9545c4e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};